import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import { restRequest } from '../../../Helpers/RequestHelper';

import OverlayLoader from '../../../Components/Loader/OverlayLoader';
import Form from '../../../Components/Form/Form';
import FormAction from '../../../Components/Form/FormAction';
import { getObjFromLS } from '../../../Helpers/LocalStorage'; //, setObjInLS
import SinglePrefixField, {
  SinglePrefixFieldNumber,
} from './SinglePrefixField';
import './Prefix.css';
import { checkError } from '../../../Helpers/AuthHelper';
import { isEqual } from 'lodash';
import { Field } from '../../../Components/Form';
import { t } from 'i18next';

class Prefix extends Component {
  state = {
    loading: true,
    showPrompt: false,
    staticVal: {},
    soFormat: '',
    soStartFrom: 1,
    sostartFromLocked: '',
    pkFormat: '',
    pkStartFrom: 1,
    pkstartFromLocked: '',
    shFormat: '',
    shStartFrom: 1,
    shstartFromLocked: '',
    invFormat: '',
    invStartFrom: 1,
    invstartFromLocked: '',
    poFormat: '',
    poStartFrom: 1,
    postartFromLocked: '',
    blFormat: '',
    blStartFrom: 1,
    blstartFromLocked: '',
    srFormat: '',
    srStartFrom: 1,
    srstartFromLocked: '',
    rrFormat: '',
    rrStartFrom: 1,
    rrstartFromLocked: '',
    crFormat: '',
    crStartFrom: 1,
    crstartFromLocked: '',
    rcvFormat: '',
    rcvStartFrom: 1,
    rcvstartFromLocked: '',
    advInvFormat: '',
    advBilFormat: '',
    skuFormat: '',
    startFrom: '',
    startFromLocked: '',
    skuTerms: '',
    isSubmitting: false,
  };

  componentDidMount() {
    localStorage.setItem('alert', false);
    this.fetchData();
    window.onbeforeunload = function () {
      return true;
    };
  }

  componentWillUnmount() {
    window.onbeforeunload = null;
  }

  componentDidUpdate(prevProps, prevState) {
    const { staticVal } = this.state;
    const {
      soFormat,
      soStartFrom,
      sostartFromLocked,
      pkFormat,
      pkStartFrom,
      pkstartFromLocked,
      shFormat,
      shStartFrom,
      shstartFromLocked,
      invFormat,
      invStartFrom,
      invstartFromLocked,
      poFormat,
      poStartFrom,
      postartFromLocked,
      blFormat,
      blStartFrom,
      blstartFromLocked,
      srFormat,
      srStartFrom,
      srstartFromLocked,
      rrFormat,
      rrStartFrom,
      rrstartFromLocked,
      crFormat,
      crStartFrom,
      crstartFromLocked,
      rcvFormat,
      rcvStartFrom,
      rcvstartFromLocked,
      //advInvFormat,
      //advBilFormat,
      skuFormat,
      startFrom,
      startFromLocked,
      skuTerms,
    } = this.state;
    const data = {
      soFormat,
      soStartFrom,
      sostartFromLocked,
      pkFormat,
      pkStartFrom,
      pkstartFromLocked,
      shFormat,
      shStartFrom,
      shstartFromLocked,
      invFormat,
      invStartFrom,
      invstartFromLocked,
      poFormat,
      poStartFrom,
      postartFromLocked,
      blFormat,
      blStartFrom,
      blstartFromLocked,
      srFormat,
      srStartFrom,
      srstartFromLocked,
      rrFormat,
      rrStartFrom,
      rrstartFromLocked,
      crFormat,
      crStartFrom,
      crstartFromLocked,
      rcvFormat,
      rcvStartFrom,
      rcvstartFromLocked,
      //advInvFormat,
      //advBilFormat,
      skuFormat,
      startFrom,
      startFromLocked,
      skuTerms,
    };
    if (prevState.showPrompt !== this.state.showPrompt) {
      const checkEquality = Boolean(isEqual(data, staticVal));
      if (!checkEquality) localStorage.setItem('alert', true);
      else localStorage.setItem('alert', false);
    }
  }

  handlePrompt = () => {
    this.setState({
      showPrompt: !this.state.showPrompt,
    });
  };

  async fetchData() {
    this.setState({ loading: true });
    await restRequest('get', 'numberPreferences/all')
      .then((res) => {
        this.setState({
          soFormat: res.sales_order_preference.preferences.soFormat,
          soStartFrom: res.sales_order_preference.preferences.startFrom,
          sostartFromLocked:
            res.sales_order_preference.preferences.startFromLocked,

          pkFormat: res.package_preference.preferences.pkFormat,
          pkStartFrom: res.package_preference.preferences.startFrom,
          pkstartFromLocked: res.package_preference.preferences.startFromLocked,

          shFormat: res.shipment_preference.preferences.shFormat,
          shStartFrom: res.shipment_preference.preferences.startFrom,
          shstartFromLocked:
            res.shipment_preference.preferences.startFromLocked,

          invFormat: res.invoice_preference.preferences.invFormat,
          invStartFrom: res.invoice_preference.preferences.startFrom,
          invstartFromLocked:
            res.invoice_preference.preferences.startFromLocked,

          poFormat: res.purchase_order_preference.preferences.poFormat,
          poStartFrom: res.purchase_order_preference.preferences.startFrom,
          postartFromLocked:
            res.purchase_order_preference.preferences.startFromLocked,

          blFormat: res.bill_preference.preferences.blFormat,
          blStartFrom: res.bill_preference.preferences.startFrom,
          blstartFromLocked: res.bill_preference.preferences.startFromLocked,

          srFormat: res.sales_return_preference.preferences.srFormat,
          srStartFrom: res.sales_return_preference.preferences.startFrom,
          srstartFromLocked:
            res.sales_return_preference.preferences.startFromLocked,

          rrFormat: res.return_receive_preference.preferences.rrFormat,
          rrStartFrom: res.return_receive_preference.preferences.startFrom,
          rrstartFromLocked:
            res.return_receive_preference.preferences.startFromLocked,

          crFormat: res.credit_note_preference.preferences.crFormat,
          crStartFrom: res.credit_note_preference.preferences.startFrom,
          crstartFromLocked:
            res.credit_note_preference.preferences.startFromLocked,

          rcvFormat: res.receive_preference.preferences.rcvFormat,
          rcvStartFrom: res.receive_preference.preferences.startFrom,
          rcvstartFromLocked:
            res.receive_preference.preferences.startFromLocked,

          //advInvFormat: res.advance_invoice_payment_preference.preferences.advInvFormat,
          //advBilFormat: res.advance_bill_payment_preference.preferences.advBilFormat,
          skuFormat: res.sku_preference.preferences.skuFormat,
          startFrom: res.sku_preference.preferences.startFrom,
          startFromLocked: res.sku_preference.preferences.startFromLocked,
          skuTerms:
            res.sku_preference.terms !== undefined
              ? res.sku_preference.terms
              : 'auto',

          staticVal: {
            soFormat: res.sales_order_preference.preferences.soFormat,
            soStartFrom: res.sales_order_preference.preferences.startFrom,
            sostartFromLocked:
              res.sales_order_preference.preferences.startFromLocked,

            pkFormat: res.package_preference.preferences.pkFormat,
            pkStartFrom: res.package_preference.preferences.startFrom,
            pkstartFromLocked:
              res.package_preference.preferences.startFromLocked,

            shFormat: res.shipment_preference.preferences.shFormat,
            shStartFrom: res.shipment_preference.preferences.startFrom,
            shstartFromLocked:
              res.shipment_preference.preferences.startFromLocked,

            invFormat: res.invoice_preference.preferences.invFormat,
            invStartFrom: res.invoice_preference.preferences.startFrom,
            invstartFromLocked:
              res.invoice_preference.preferences.startFromLocked,

            poFormat: res.purchase_order_preference.preferences.poFormat,
            poStartFrom: res.purchase_order_preference.preferences.startFrom,
            postartFromLocked:
              res.purchase_order_preference.preferences.startFromLocked,

            blFormat: res.bill_preference.preferences.blFormat,
            blStartFrom: res.bill_preference.preferences.startFrom,
            blstartFromLocked: res.bill_preference.preferences.startFromLocked,

            srFormat: res.sales_return_preference.preferences.srFormat,
            srStartFrom: res.sales_return_preference.preferences.startFrom,
            srstartFromLocked:
              res.sales_return_preference.preferences.startFromLocked,

            rrFormat: res.return_receive_preference.preferences.rrFormat,
            rrStartFrom: res.return_receive_preference.preferences.startFrom,
            rrstartFromLocked:
              res.return_receive_preference.preferences.startFromLocked,

            crFormat: res.credit_note_preference.preferences.crFormat,
            crStartFrom: res.credit_note_preference.preferences.startFrom,
            crstartFromLocked:
              res.credit_note_preference.preferences.startFromLocked,

            rcvFormat: res.receive_preference.preferences.rcvFormat,
            rcvStartFrom: res.receive_preference.preferences.startFrom,
            rcvstartFromLocked:
              res.receive_preference.preferences.startFromLocked,

            //advInvFormat: res.advance_invoice_payment_preference.preferences.advInvFormat,
            //advBilFormat: res.advance_bill_payment_preference.preferences.advBilFormat,
            skuFormat: res.sku_preference.preferences.skuFormat,
            startFrom: res.sku_preference.preferences.startFrom,
            startFromLocked: res.sku_preference.preferences.startFromLocked,
            skuTerms:
              res.sku_preference.terms !== undefined
                ? res.sku_preference.terms
                : 'auto',
          },
        });
      })
      .catch((error) => {
        checkError(error, this.props.handleToast);
        this.setState({ loading: false });
      });
    this.setState({ loading: false });
  }

  handleSubmit = (event) => {
    event.preventDefault();
    let updatedStates = { ...this.state };
    delete updatedStates.isSubmitting;
    delete updatedStates.loading;
    //this.setState({ isSubmitting: false });
    this.setState({ isSubmitting: true });
    restRequest('put', 'numberPreferences/all', updatedStates)
      .then(() => {
        this.setState({ isSubmitting: false });
        this.props.handleToast(t('Preferences.changes_updated_successfully'), 'success');
        this.props.setPrompt(false);
        this.fetchData();
      })
      .catch((error) => {
        this.setState({ isSubmitting: false });
        this.props.handleToast(error, 'error');
        checkError(error);
      });
  };

  renderActionButtons() {
    let permissions = getObjFromLS('role').permissions;
    if (!permissions.superAccess) {
      if (permissions.PreferenceEdit) {
        return (
          <FormAction
            disabled={this.state.isSubmitting}
            onCancel={() => this.props.history.push('/settings')}
          />
        );
      }
    }
    if (permissions.superAccess) {
      return (
        <FormAction
          disabled={this.state.isSubmitting}
          onCancel={() => this.props.history.push('/settings')}
        />
      );
    }
  }

  changeSOFormat(val) {
    this.setState({ soFormat: val });
    this.handlePrompt();
  }
  changepkFormat(val) {
    this.setState({ pkFormat: val });
    this.handlePrompt();
  }
  changeShFormat(val) {
    this.setState({ shFormat: val });
    this.handlePrompt();
  }
  changeInvFormat(val) {
    this.setState({ invFormat: val });
    this.handlePrompt();
  }
  changePoFormat(val) {
    this.setState({ poFormat: val });
    this.handlePrompt();
  }
  changeBlFormat(val) {
    this.setState({ blFormat: val });
    this.handlePrompt();
  }
  changeRrFormat(val) {
    this.setState({ rrFormat: val });
    this.handlePrompt();
  }
  changeCrFormat(val) {
    this.setState({ crFormat: val });
    this.handlePrompt();
  }
  changeRcvFormat(val) {
    this.setState({ rcvFormat: val });
    this.handlePrompt();
  }
  /*changeAdvInvFormat(val) {
    this.setState({ advInvFormat: val });
    this.handlePrompt();
  }
  changeAdvBillFormat(val) {
    this.setState({advBilFormat: val });
    this.handlePrompt();
  }*/
  changeSrFormat(val) {
    this.setState({ srFormat: val });
    this.handlePrompt();
  }
  changeSkuFormat(val) {
    this.setState({ skuFormat: val });
    this.handlePrompt();
  }

  changeStartFrom(val) {
    this.setState({ startFrom: val });
    this.handlePrompt();
  }
  handleStartFrom = (key, value) => {
    this.setState({ [key]: value }, this.handlePrompt);
  };

  updateOptions(obj, option) {
    let updatedObj = option;
    let objNew = document.getElementById(option);
    objNew.checked = true;
    objNew.value = option;

    if (updatedObj === 'auto') {
      document.getElementById('auto').checked = true;
      document.getElementById('manual').checked = false;
    } else {
      document.getElementById('auto').checked = false;
      document.getElementById('manual').checked = true;
    }
    return objNew;
  }

  handleRadioChange = (event) => {
    // let stateName = event.target.name;
    // let option = event.target.id;
    // let updatedOptions = this.updateOptions(stateName, option);
    // this.setState((state) => ({
    //   [stateName]: {
    //     ...state[stateName],
    //     ...option,
    //   },
    // }));
    this.setState({
      skuTerms: event.target.value,
    });
    this.handlePrompt();
  };

  handleRadioClick(radioOption, radiostateName) {
    let stateName = radiostateName;
    let option = radioOption;
    this.setState({ skuTerms: radioOption });
    this.updateOptions(stateName, option);
  }

  renderStatusChangeInput() {
    const { loading } = this.state;
    return (
      <Form onSubmit={this.handleSubmit}>
        {loading && <OverlayLoader />}
        <div className="float-left w-100 height_custom__ preference-height prefix-main">
          <div
            className="float-left w-70 h-100 right_sec"
            style={{ padding: '10px 0px 10px 0px' }}
          >
            <div className="add_prefix float-left w-100">
              {t('Preferences.add_custom_prefixes')}({' '}
              <p>
                {t('Preferences.ie_for')}
                <i>{t('Preferences.sales_order')}</i>{' '}
                {t('Preferences.you_can_use')} <i>{t('Preferences.so')}</i>{' '}
              </p>{' '}
              )
            </div>
            <div className="float-left w-50 prefixes">
              <SinglePrefixField
                loading={loading}
                label={t('Preferences.sales_order_prefix')}
                value={this.state.soFormat}
                handleChange={this.changeSOFormat.bind(this)}
              />

              <SinglePrefixField
                loading={loading}
                label={t('Preferences.shipment_prefix')}
                value={this.state.shFormat}
                handleChange={this.changeShFormat.bind(this)}
              />

              <SinglePrefixField
                loading={loading}
                label={t('Preferences.purchase_order')}
                value={this.state.poFormat}
                handleChange={this.changePoFormat.bind(this)}
              />

              <SinglePrefixField
                loading={loading}
                label={t('Preferences.sales_return_prefix')}
                value={this.state.srFormat}
                handleChange={this.changeSrFormat.bind(this)}
              />

              <SinglePrefixField
                loading={loading}
                label={t('Preferences.credit_note_prefix')}
                value={this.state.crFormat}
                handleChange={this.changeCrFormat.bind(this)}
              />

              {/*<SinglePrefixField
                loading={loading}
                label="Advance Invoice Payment Prefix"
                value={this.state.advInvFormat}
                handleChange={this.changeAdvInvFormat.bind(this)}
              />*/}
              <SinglePrefixField
                loading={loading}
                label={t('Preferences.package_prefix')}
                value={this.state.pkFormat}
                handleChange={this.changepkFormat.bind(this)}
              />
              <SinglePrefixField
                loading={loading}
                label={t('Preferences.invoices_prefix')}
                value={this.state.invFormat}
                handleChange={this.changeInvFormat.bind(this)}
              />
              <SinglePrefixField
                loading={loading}
                label={t('Preferences.bill_prefix')}
                value={this.state.blFormat}
                handleChange={this.changeBlFormat.bind(this)}
              />
              <SinglePrefixField
                loading={loading}
                label={t('Preferences.return_receive_prefix')}
                value={this.state.rrFormat}
                handleChange={this.changeRrFormat.bind(this)}
              />
              <SinglePrefixField
                loading={loading}
                label={t('Preferences.receive_prefix')}
                value={this.state.rcvFormat}
                handleChange={this.changeRcvFormat.bind(this)}
              />
            </div>
            <div className="float-left w-50">
              <SinglePrefixField
                disabled={this.state.sostartFromLocked}
                loading={loading}
                label={t('Preferences.sale_order_start_from')}
                value={this.state.soStartFrom}
                handleChange={(val) => this.handleStartFrom('soStartFrom', val)}
              />
              <SinglePrefixField
                disabled={this.state.shstartFromLocked}
                loading={loading}
                label={t('Preferences.shipment_start_from')}
                value={this.state.shStartFrom}
                handleChange={(val) => this.handleStartFrom('shStartFrom', val)}
              />
              <SinglePrefixField
                disabled={this.state.postartFromLocked}
                loading={loading}
                label={t('Preferences.purchase_start_from')}
                value={this.state.poStartFrom}
                handleChange={(val) => this.handleStartFrom('poStartFrom', val)}
              />

              <SinglePrefixField
                disabled={this.state.srstartFromLocked}
                loading={loading}
                label={t('Preferences.sales_return_start_from')}
                value={this.state.srStartFrom}
                handleChange={(val) => this.handleStartFrom('srStartFrom', val)}
              />
              <SinglePrefixField
                disabled={this.state.crstartFromLocked}
                loading={loading}
                label={t('Preferences.credit_note_start_from')}
                value={this.state.crStartFrom}
                handleChange={(val) => this.handleStartFrom('crStartFrom', val)}
              />

              <SinglePrefixField
                disabled={this.state.pkstartFromLocked}
                loading={loading}
                label={t('Preferences.package_start_from')}
                value={this.state.pkStartFrom}
                handleChange={(val) => this.handleStartFrom('pkStartFrom', val)}
              />
              <SinglePrefixField
                disabled={this.state.invstartFromLocked}
                loading={loading}
                label={t('Preferences.invoices_start_from')}
                value={this.state.invStartFrom}
                handleChange={(val) =>
                  this.handleStartFrom('invStartFrom', val)
                }
              />

              <SinglePrefixField
                disabled={this.state.blstartFromLocked}
                loading={loading}
                label={t('Preferences.bill_prefix_start_from')}
                value={this.state.blStartFrom}
                handleChange={(val) => this.handleStartFrom('blStartFrom', val)}
              />

              <SinglePrefixField
                disabled={this.state.rrstartFromLocked}
                loading={loading}
                label={t('Preferences.return_receive_prefix_start_from')}
                value={this.state.rrStartFrom}
                handleChange={(val) => this.handleStartFrom('rrStartFrom', val)}
              />

              <SinglePrefixField
                disabled={this.state.rcvstartFromLocked}
                loading={loading}
                label={t('Preferences.receive_prefix_start_from')}
                value={this.state.rcvStartFrom}
                handleChange={(val) =>
                  this.handleStartFrom('rcvStartFrom', val)
                }
              />

              {/*<SinglePrefixField
                loading={loading}
                label="Advance Bill Payment Prefix"
                value={this.state.advBilFormat}
                handleChange={this.changeAdvBillFormat.bind(this)}
              />*/}
            </div>
            <div
              className="float-left w-50 prefixes prefixes-main-set"
              style={{ paddingTop: '5px', borderTop: '1px solid #CCCCCC' }}
            >
              <SinglePrefixField
                loading={loading}
                label={t('Preferences.sku_prefix')}
                value={this.state.skuFormat}
                handleChange={this.changeSkuFormat.bind(this)}
              />
              <SinglePrefixField
                disabled={this.state.startFromLocked !== '' ? true : false}
                loading={loading}
                label={t('Preferences.sku_start_from')}
                value={this.state.startFrom}
                handleChange={this.changeStartFrom.bind(this)}
              />
            </div>
            <div
              className="float-left w-50 prefixes prefixes-main-set prefixes-main-child"
              style={{ paddingTop: '5px', borderTop: '1px solid #CCCCCC' }}
            >
              <div className="float-left w-5">
                <input
                  type="radio"
                  checked={this.state.skuTerms === 'auto' ? true : false}
                  onChange={(event) => this.handleRadioChange(event)}
                  name="skuTerms"
                  id="auto"
                  // value={this.state.skuTerms}
                  value="auto"
                />
              </div>
              <div className="float-left w-95">
                <label htmlFor="auto" style={{ marginBottom: '5px' }}>
                  {t('Preferences.auto_generate_sku_serial_number')}
                </label>
                <span
                  onClick={() => this.handleRadioClick('auto', 'skuTerms')}
                  className="radio-circle"
                  style={{ border: 'none', width: '16%' }}
                />
              </div>
              <div className="float-left w-5">
                <input
                  type="radio"
                  checked={this.state.skuTerms === 'manual' ? true : false}
                  onChange={(event) => this.handleRadioChange(event)}
                  name="skuTerms"
                  id="manual"
                  // value={this.state.skuTerms}
                  value="manual"
                />
              </div>
              <div className="float-left w-95">
                <label htmlFor="manual" style={{ marginBottom: '5px' }}>
                  {t('Preferences.continue_from_last_sku_number')}
                </label>
                <span
                  onClick={() => this.handleRadioClick('manual', 'skuTerms')}
                  className="radio-circle"
                  style={{ border: 'none', width: '14%' }}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="float-left w-100">
          <div className="float-left w-70">
            {/* <hr /> */}
            {this.renderActionButtons()}
          </div>
        </div>
      </Form>
    );
  }

  render() {
    return this.renderStatusChangeInput();
  }
}

export default withRouter(Prefix);
